export class ReversiFailure {
    static NO_ELEMENT_SWITCHED = () => $localize `Your move should switch at least one piece.`;
}
